import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'shared/defaults.scss';
import raven from 'shared/errors/raven';
import env from 'shared/env';
import Raven from 'raven-js';

if (!__DEV__) {
  raven.initialize(env(window).SENTRY_PUBLIC_DSN, Raven);
}
